<template>
  <AppSection top>
    <AppContainer>
      <h1 class="mb-8">{{ title }}</h1>
      <AppThirdLayout>
        <AppImg src="/images/sad-emoji.jpg" :alt="$tt('failure_page.sad_emoji_img')" />
        <div>
          <h4 class="mb-7">{{ $tt('failure_page.oops') }}</h4>
          <h3 v-html="$tt('failure_page.saved')" />
          <p v-html="$tt('failure_page.contact')" />
          <p>{{ $tt('failure_page.chat') }}</p>
        </div>
      </AppThirdLayout>
    </AppContainer>

    <ChatWidget auto-open />
  </AppSection>
</template>

<script setup lang="ts">
const { tt } = useLocalization();
const title = tt('failure_page.failed');
useHead({ title });
</script>

<style scoped>
@media (max-width: 850px) {
  img {
    max-width: 360px;
    width: 100%;
    margin: auto;
  }
  h1, h4 {
    text-align: center;
  }
  h1 {
    margin-bottom: var(--space-4) !important;
    font-size: 32px;
  }
  h4 {
    font-size: 20px;
  }
}
</style>